// extracted by mini-css-extract-plugin
export default {"root":"root--MLpJ6","thumbnail":"thumbnail--RsiB_"};